// extracted by mini-css-extract-plugin
export var outer = "demo-video-modal-module--outer--3mRE5";
export var outerEnter = "demo-video-modal-module--outer-enter--P4Gau";
export var exit = "demo-video-modal-module--exit--2vKYb";
export var outerExit = "demo-video-modal-module--outer-exit--3fPsj";
export var inner = "demo-video-modal-module--inner--3oa4h";
export var innerEnter = "demo-video-modal-module--inner-enter--1bGy3";
export var innerExit = "demo-video-modal-module--inner-exit--2xrQf";